/* Nuzzo Kid FR — buy box + cart drawer (Shopify Cart AJAX API) */
(function () {
  var fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  function money(cents) { return fmt.format(cents / 100); }

  /* ---------------- buy box ---------------- */
  function initBuyBox(root) {
    var radios = root.querySelectorAll('[data-bundle-radio]');
    var qtyOut = root.querySelector('[data-qty-out]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var subtotalEl = root.querySelector('[data-subtotal]');
    var variantInput = root.querySelector('[data-variant-input]');
    var protectionPrice = parseInt(root.dataset.protectionPrice || '0', 10);
    var compareEl = root.querySelector('[data-subtotal-compare]');
    var compareMode = root.dataset.subtotalCompareMode || 'variant';
    var qty = 1;

    function selected() {
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
      return radios[0];
    }
    function protectionOn() {
      var card = selected().closest('[data-bundle]');
      var cb = card && card.querySelector('[data-protection]');
      return !!(cb && cb.checked);
    }
    function render() {
      var r = selected();
      root.querySelectorAll('[data-bundle]').forEach(function (c) {
        c.classList.toggle('is-selected', c.contains(r));
      });
      if (variantInput) variantInput.value = r.value;
      if (qtyOut) qtyOut.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      var cents = parseInt(r.dataset.price, 10) * qty + (protectionOn() ? protectionPrice : 0);
      if (subtotalEl) subtotalEl.textContent = money(cents);

      // What the struck figure counts is a merchant decision, so it comes from
      // a setting: the variant's own compare-at, or that plus the advertised
      // worth of the gifts in this tier. Never shown unless it beats the price
      // actually being charged - a strike at or below the real total reads as
      // a mistake, and an inflated one is worse than none.
      if (compareEl) {
        var was = 0;
        if (compareMode !== 'off') {
          was = parseInt(r.dataset.compare || '0', 10) * qty;
          if (!was) was = parseInt(r.dataset.price, 10) * qty;
          if (compareMode === 'withperks') {
            var card = r.closest('[data-bundle]');
            if (card) {
              card.querySelectorAll('[data-nz-perk-worth]').forEach(function (row) {
                was += parseInt(row.getAttribute('data-nz-perk-worth'), 10) || 0;
              });
            }
          }
        }
        if (was > cents) {
          compareEl.textContent = money(was);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-bundle-radio],[data-protection]')) render();
    });
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (!step) return;
      e.preventDefault();
      qty = Math.min(9, Math.max(1, qty + parseInt(step.dataset.qtyStep, 10)));
      render();
    });

    var form = root.querySelector('[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var r = selected();
        var items = [{ id: parseInt(r.value, 10), quantity: qty }];
        var protId = root.dataset.protectionVariant;
        if (protectionOn() && protId) items.push({ id: parseInt(protId, 10), quantity: 1 });
        // Free perks belonging to the selected tier ride along in the same
        // request, so they appear in the cart and at checkout rather than only
        // on the page. Dedupe: the same product may be listed under two tiers.
        var card = r.closest('[data-bundle]');
        if (card) {
          card.querySelectorAll('[data-nz-perk-variant]').forEach(function (row) {
            var pid = parseInt(row.getAttribute('data-nz-perk-variant'), 10);
            if (pid && !items.some(function (it) { return it.id === pid; })) {
              items.push({ id: pid, quantity: 1 });
            }
          });
        }
        var btn = form.querySelector('[data-add-btn]');
        if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = '…'; }
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            // The store already renders one cart drawer site-wide. Hand off to
            // it when it is there, so a page does not ship a second drawer of
            // its own; furly:cart:refresh re-renders and opens in one step.
            // Fall back to the bundled drawer if that one is absent.
            if (document.getElementById('FurlyCartDrawer') ||
                document.querySelector('[id^="FurlyCartDrawer"]')) {
              document.dispatchEvent(new CustomEvent('furly:cart:refresh', { bubbles: true }));
              return;
            }
            return NuzzoCart.refresh().then(function () { NuzzoCart.open(); });
          })
          .catch(function (err) { console.error(err); })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
          });
      });
    }
    render();
  }

  /* ---------------- cart drawer ---------------- */
  var NuzzoCart = {
    el: null,
    timerId: null,
    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el) return;
      var self = this;
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-open]')) { e.preventDefault(); self.open(); }
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); self.close(); }
        var step = e.target.closest('[data-line-step]');
        if (step) {
          e.preventDefault();
          self.change(step.dataset.lineKey, parseInt(step.dataset.lineQty, 10) + parseInt(step.dataset.lineStep, 10));
        }
        var rm = e.target.closest('[data-line-remove]');
        if (rm) { e.preventDefault(); self.change(rm.dataset.lineKey, 0); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      this.startTimer();
    },
    open: function () { if (this.el) { this.el.classList.add('is-open'); document.body.style.overflow = 'hidden'; this.startTimer(); } },
    close: function () { if (this.el) { this.el.classList.remove('is-open'); document.body.style.overflow = ''; } },
    change: function (key, quantity) {
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function () { return self.refresh(); });
    },
    refresh: function () {
      var self = this;
      var url = window.Shopify.routes.root + '?section_id=nuzzo-cart-drawer';
      return fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          if (!fresh || !self.el) return;
          var wasOpen = self.el.classList.contains('is-open');
          self.el.querySelector('[data-cart-body]').innerHTML = fresh.querySelector('[data-cart-body]').innerHTML;
          self.el.querySelector('[data-cart-count]').textContent = fresh.querySelector('[data-cart-count]').textContent;
          document.querySelectorAll('[data-cart-bubble]').forEach(function (b) {
            b.textContent = fresh.querySelector('[data-cart-count-raw]') ? fresh.querySelector('[data-cart-count-raw]').textContent : b.textContent;
          });
          if (wasOpen) self.el.classList.add('is-open');
        });
    },
    startTimer: function () {
      var out = this.el && this.el.querySelector('[data-cart-timer]');
      if (!out || this.timerId) return;
      var left = parseInt(out.dataset.seconds || '272', 10);
      var label = out.dataset.label || 'Panier réservé pendant';
      var self = this;
      function tick() {
        var m = Math.floor(left / 60), s = left % 60;
        out.textContent = label + ' ' + m + ':' + (s < 10 ? '0' : '') + s;
        if (left <= 0) { clearInterval(self.timerId); self.timerId = null; return; }
        left--;
      }
      tick();
      this.timerId = setInterval(tick, 1000);
    }
  };
  window.NuzzoCart = NuzzoCart;

  function boot() {
    document.querySelectorAll('[data-buy-box]').forEach(initBuyBox);
    NuzzoCart.init();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
